<template>
  <path pid="0" d="M23.11 10a3 3 0 00-2.3-1h-4.65V6a4 4 0 00-4-4 1 1 0 00-.92.59L7.51 11H5.16a3 3 0 00-3 3v7a3 3 0 003 3h14.28a3 3 0 003-2.55l1.38-9a3 3 0 00-.71-2.45zM7.16 22h-2a1 1 0 01-1-1v-7a1 1 0 011-1h2zm13.29-.85a1 1 0 01-1 .85H9.16v-9.79l3.61-8.12A2 2 0 0114.16 6v4a1 1 0 001 1h5.66a1 1 0 01.78.34 1 1 0 01.23.81z"/>
</template>
